import { DesignationOutputWithStatus } from './designation-output-with-status.model';


export class DesignationSelectByIdOutput implements IDesignationSelectByIdOutput {
    status!: number;
    message!: string;
    data!: DesignationOutputWithStatus;

    constructor(data?: IDesignationSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? DesignationOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DesignationSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDesignationSelectByIdOutput {
    status: number;
    message: string;
    data: DesignationOutputWithStatus;
}

